export function getSlug(str, type = "-") {
    return str.toLowerCase().replace(/ /g, type);
}
